import { createSlice } from '@reduxjs/toolkit';
import {fetchUserHomeOwnerDataApi} from '../HomeownerApi';

const HomeOwnerAllDataSlice = createSlice({
  name: 'HomeOwnerAllData',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchUserHomeOwnerDataApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserHomeOwnerDataApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchUserHomeOwnerDataApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default HomeOwnerAllDataSlice.reducer;
